const HttpStatus = {
  success: 200,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  methodNotAllowed: 405,
  internalServerError: 500
};

const getUrl = (url) => url;

const routeAPI = {};
routeAPI.CONSIGNORS = 'consignors';
routeAPI.CONSIGNOR_GROUPS = 'consignor-groups';

export { getUrl, HttpStatus, routeAPI };
